module.exports = __webpack_public_path__ + "static/media/nav-dashboard.102a2686.svg";